import Alpine from "alpinejs"
import ResizePlugin from "@alpinejs/resize"

Alpine.plugin(ResizePlugin)

Alpine.data("navigation", () => ({
    searchActive: false,
    init() {
        Alpine.bind(this.$root, this.root)
        document.body.style.setProperty("--c-navigation-height", `${this.$el.getBoundingClientRect().height}px`)
    },
    root: {
        ["x-resize.document"]() {
            this.isMobile = this.$width < 1056
            if (this.mobileOpen && !this.isMobile && this.openIndex !== null) {
                this.closeMobileMenu()
                const index = this.openIndex
                clearTimeout(this.updateCall)
                requestAnimationFrame(() => {
                    this.openItem(index)
                    this.updateCall = setTimeout(() => {
                        this.updateHeight()
                    }, 0)
                })
            }
            if (!this.mobileOpen && this.isMobile && this.openIndex !== null && !this.$refs.mobileDialog.open) {
                this.__navitems.forEach((item) => {
                    item.open = false
                })
                this.openMobileMenu()
                this.openItem(this.openIndex)
            }
        },
        ["@resize.debounce.window"]() {
            clearTimeout(this.updateCall)
            this.updateCall = setTimeout(() => {
                this.updateHeight()
            }, 0)
        },
    },

    updateCall: null,
    isMobile: false,
    _openIndex: null,
    get openIndex() {
        return this._openIndex
    },
    set openIndex(value) {
        this._openIndex = value
        this.updateHeight()
    },

    height: 0,

    updateHeight() {
        this.$nextTick(() => {
            this.height =
                this.openIndex !== null
                    ? this.__navitems[this.openIndex].$el.querySelector(".js-flyout > .grid").getBoundingClientRect().height
                    : 0

            if (this.openIndex !== null) {
                this.__navitems[this.openIndex].$el.querySelector(".js-flyout").style.maxHeight = (window.innerHeight - this.__navitems[this.openIndex].$el.querySelector(".js-flyout").getBoundingClientRect().top) + 'px'
            }
        })
    },

    __navitemsMobile: [],
    __navitems: [],

    get navitems() {
        return this.isMobile ? this.__navitemsMobile : this.__navitems
    },
    addNavitem(item, index, mobile = false) {
        if (mobile) {
            this.__navitemsMobile[index] = item
        } else {
            this.__navitems[index] = item
        }
    },

    close(index) {
        const currentItem = this.navitems?.[this.openIndex]
        const newItem = this.navitems[index]
        if (currentItem) {
            currentItem.open = false
        }
        if (newItem) {
            newItem.open = false
        }
        this.openIndex = null
        this.focusItem(index)
    },
    blur(index) {
        if (this.openIndex === index) {
            this.toggleItem(index)
        }
    },
    toggleItem(index) {
        const currentItem = this.navitems?.[this.openIndex]
        const newItem = this.navitems[index]
        if (this.openIndex === index) {
            currentItem.open = false
            this.openIndex = null
        } else {
            if (this.openIndex !== null) {
                currentItem.open = false
            }
            if (newItem?.hasFlyout) {
                newItem.open = true
                this.openIndex = index
            } else {
                newItem.open = false
                this.openIndex = null
            }
        }
    },
    focusItem(index) {
        this.navitems?.[index]?.$el.querySelector(".c-nav-item__button")?.focus()
    },
    nextItem(index) {
        const currentItem = this.navitems?.[index]
        const flyoutOpen = currentItem.open
        const newItem = this.navitems[(index + 1) % this.navitems.length]
        currentItem.open = false
        if (newItem.hasFlyout) {
            newItem.open = flyoutOpen
        }
        this.focusItem((index + 1) % this.navitems.length)
    },
    prevItem(index) {
        const currentItem = this.navitems?.[index]
        const flyoutOpen = currentItem.open
        const newItem = this.navitems[(this.navitems.length + index - 1) % this.navitems.length]
        currentItem.open = false
        if (newItem.hasFlyout) {
            newItem.open = flyoutOpen
        }
        this.focusItem((this.navitems.length + index - 1) % this.navitems.length)
    },
    openItem(index) {
        const currentItem = this.navitems?.[this.openIndex]
        if (this.openIndex !== index) {
            if (currentItem) {
                currentItem.open = false
            }
            this.openIndex = index
        }

        const newItem = this.navitems?.[index]
        if (newItem?.hasFlyout) {
            newItem.open = true
        }
        newItem?.$el.querySelector(".js-flyout :is(a,button)")?.focus()
    },
    closeItem(index) {
        const currentItem = this.navitems?.[this.openIndex]
        if (this.openIndex !== index) {
            if (currentItem) {
                currentItem.open = false
            }
        }

        const newItem = this.navitems?.[index]
        if (newItem) {
            newItem.open = false
        }
        this.openIndex = null
        this.focusItem(index)
    },

    downFlyout(event, index) {
        const elements = [...event.currentTarget.querySelectorAll(":is(button,a)")]
        const nextElement = elements.slice(elements.indexOf(event.target) + 1, elements.length)?.[0]
        if (nextElement) {
            nextElement?.focus()
        } else if (!this.isMobile) {
            this.focusItem(index)
        }
    },
    upFlyout(event, index) {
        const elements = [...event.currentTarget.querySelectorAll(":is(button,a)")]
        const nextElement = elements.slice(0, elements.indexOf(event.target))?.at(-1)
        if (nextElement) {
            nextElement?.focus()
        } else if (!this.isMobile) {
            this.closeItem(index)
        }
    },

    navitem: (index, navigation, hasFlyout) => {
        const navitem = {
            init() {
                this.parent = navigation
                this.parent.addNavitem(navitem, index, false)
            },
            index,
            hasFlyout,
            __open: false,
            get open() {
                return navitem.__open
            },
            set open(open) {
                navitem.__open = open
            },
        }

        return navitem
    },

    // MOBILE
    mobileOpen: false,
    toggleMobileMenu() {
        if (this.mobileOpen) {
            this.closeMobileMenu()
        } else {
            this.openMobileMenu()
        }
        this.openIndex = null
    },
    openMobileMenu() {
        this.$refs.mobileDialog.showModal()
        document.body.inert = true
        this.mobileOpen = true
    },
    closeMobileMenu() {
        this.$refs.langswitch.close()
        this.$refs.mobileDialog.close()
        document.body.inert = false
        this.mobileOpen = false
        this.__navitemsMobile.forEach((item) => {
            item.open = false
        })
        this.$refs.mobileOpenButton.focus()
    },

    navitemMobile: (index, navigation, hasFlyout) => {
        const navitem = {
            init() {
                this.parent = navigation
                this.parent.addNavitem(navitem, index, true)
            },
            index,
            hasFlyout,
            get open() {
                return navitem.$refs.dialog.open
            },
            set open(open) {
                if (open) {
                    this.$refs.dialog?.show()
                } else {
                    this.$refs.dialog?.close()
                }
            },
        }

        return navitem
    },

    langSwitchOpen: false,
    toggleLanguageSwitch() {
        if (!this.langSwitchOpen) {
            this.langSwitchOpen = true
            this.$refs.langswitch.show()
        } else {
            this.langSwitchOpen = false
            this.$refs.langswitch.close()
        }
    },
    closeLanguageSwitch() {
        this.langSwitchOpen = false
    },
}))
